import { TpWebGl2DContext } from './interfaces';

export function setWebGLZoomPan(webGlCtx: TpWebGl2DContext, program: any) {
  // converts the scaling info to the appropriate webgl parameters, used in each vertex shader

  const gl = webGlCtx.gl;

  function convert(scale: { sMin: number; sMax: number }): { offset: number; zoom: number } {
    return {
      offset: (scale.sMin + scale.sMax) / 2,
      zoom: 2 / (scale.sMax - scale.sMin),
    };
  }

  const mapX = convert(webGlCtx.scaleX);
  const mapY = convert(webGlCtx.scaleY);

  // Setting zoom & pan
  gl.uniform2f(program.locPanOffset!, mapX.offset, mapY.offset);
  gl.uniform2f(program.locZoomFactor!, mapX.zoom, mapY.zoom);
}
